import React from 'react'
import {
  CButton,
  CFormGroup,
  CModal,
  CModalBody,
} from "@coreui/react";
import { useTranslation } from "react-i18next";
import {useForm} from "react-hook-form";

const MultiFactorAuthentication = (props) => {
  const { i18n } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const onSubmit = (data) => {
    props.onSubmitMfaCode(data)
  }

  return (
    <CModal show={props.modal} closeOnBackdrop={false}>
      <div className="atlas-header-mfa text-center">
        <img alt={'PTC Logo'} src="https://ptc-p-001.sitecorecontenthub.cloud/api/public/content/ff2edff8b42c48c98e20ad26ede84577?v=aabd3d85"/>
        <h1>{i18n.t('pages.users.verification')}</h1><br/>
        <div className="mfa-help-text">
          <p>Check your preferred one-time password application for a code and enter it below.</p>
        </div>
      </div>
      <CModalBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          <CFormGroup>
            <input
              type="text"
              className="form-control"
              id="totpToken"
              placeholder="Enter your one-time code"
              {...register('totpToken', {
                required: 'Authentication Code is required',
              })}
            />
            {errors?.totpToken?.message && (
              <div className="invalid-feedback">{errors.totpToken.message}</div>
            )}
            {props?.errorMessage && (
              <div className="invalid-feedback">{props.errorMessage}</div>
            )}
          </CFormGroup>
          <div>
            <CButton disabled={props.verificationLoading} type="submit" size="md" color="success">
              { !props.verificationLoading && i18n.t('global.continue') }
              { props.verificationLoading &&
                <>
                  { props.verificationLoading && i18n.t('global.loading') }
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                </>
              }
            </CButton>
          </div>
        </form>
      </CModalBody>
    </CModal>
  )
}

export default MultiFactorAuthentication
